import { AUMChartModule } from './aumchart/aumchart.module';
import { AmcmastertransactionComponent } from './profile/profile/amcmastertransaction/amcmastertransaction.component';
import { SitedisclaimerComponent } from './sitedisclaimer/sitedisclaimer.component';
// import { LoginEmployeeAlankitComponent } from './login-employee-alankit/login-employee-alankit.component';
// import { EmployeeLoginComponent } from './employee-login/employee-login.component';
// import { LoginClientAlankitComponent } from './login-client-alankit/login-client-alankit.component';
// import { LoginMahindraModule } from './login-mahindra/login-mahindra.module';

import { environment } from 'src/environments/environment';
import { CpAccessGuard } from './Auth/cp-access.guard';
import { EmpAccessGuard } from './Auth/emp-access.guard';
import { ClientAccessGuard } from './Auth/client-access.guard';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './Auth/auth.guard';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
// import { LoginMahindraComponent } from './login-mahindra/login-mahindra.component';
import { MobileLogoutComponent } from './mobile-logout/mobile-logout.component';
import { BSEGuardGuard } from './Auth/bseguard.guard';
import { NSEGuardGuard } from './Auth/nseguard.guard';
import { RoleAccessGuard } from './Auth/role-access.guard';
// import { FdPaymentComponent } from './FD/fd-payment/fd-payment.component';
import { LoginComponent } from './login/login.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { MPINLoginComponent } from './mpinlogin/mpinlogin.component';
import { ClientPdfschedulerComponent } from './client-pdfscheduler/client-pdfscheduler.component';
import { TermsConditionComponent } from './terms-condition/terms-condition.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { HelpPolicyComponent } from './help-policy/help-policy.component';
import { LegalSectionComponent } from './legal-section/legal-section.component';
import { BottomsheetbarComponent } from './transact/bottomsheetbar/bottomsheetbar.component';
import { NewnfoComponent } from './transact/newnfo/newnfo.component';

const routes: Routes = [
  {
    path: '',
    redirectTo:
      environment.CompayName == 'IFA' && !environment.IsOptimoney
        ? '/mfmain/home'
        : environment.CompayName == 'IFA' && environment.IsOptimoney
          ? '/login'
          : 'login/corp',
    pathMatch: 'full'
  },
  {
    path: environment.CompayName == 'IFA' ? 'login/investor' : 'login-corp',
    component: LoginComponent
  },
  {
    path: 'mfmain',
    loadChildren: () =>
      import('./ifaprelogin/ifaprelogin.module').then(
        (m) => m.IfapreloginModule
      )
  },

  {
    path: 'client-dashboard',
    loadChildren: () =>
      import('./client-dashboard/client-dashboard.module').then(
        (m) => m.ClientDashboardModule
      ),
    canActivate: [AuthGuard, ClientAccessGuard]
  },
  {
    path: 'calculators',
    loadChildren: () =>
      import('./calculators/calculators.module').then(
        (m) => m.CalculatorsModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'access-denied',
    loadChildren: () =>
      import('./access-denied/access-denied.module').then(
        (m) => m.AccessDeniedModule
      )
  },
  {
    path: 'clients',
    loadChildren: () =>
      import('./clients/clients.module').then((m) => m.ClientsModule),
    canActivate: [AuthGuard, RoleAccessGuard],

  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [AuthGuard],
    data: {
      noReuse: false,
      storeRoute: true,
    }
  },
  {
    path: 'factsheet',
    loadChildren: () =>
      import('./factsheet/factsheet.module').then((m) => m.FactsheetModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'forgot-password',
    loadChildren: () =>
      import('./forgot-password/forgot-password.module').then(
        (m) => m.ForgotPasswordModule
      )
  },

  //{ path: 'resetpassword-mfd', loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  //{ path: 'resetpassword-investor', loadChildren: () => import('./generate-one-time-password/generate-one-time-password.module').then(m => m.GenerateOneTimePasswordModule) },
  {
    path: 'generate-password',
    loadChildren: () =>
      import(
        './generate-one-time-password/generate-one-time-password.module'
      ).then((m) => m.GenerateOneTimePasswordModule)
  },

  {
    path: 'login',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'login/investor',
    loadChildren: () =>
      import('./login/login.module').then((m) => m.LoginModule)
  },
  {
    path: 'client-onboarding',
    loadChildren: () =>
      import('./onboarding/client-onboarding/client-onboarding.module').then(
        (m) => m.ClientOnboardingModule
      )
  },
  {
    path: 'distributor-onboarding',
    loadChildren: () =>
      import(
        './onboarding/distributor-onboarding/distributor-onboarding.module'
      ).then((m) => m.DistributorOnboardingModule)
  },
  {
    path: 'client-preOnboading',
    loadChildren: () =>
      import(
        './onboarding/client-pre-onboarding/client-pre-onboarding.module'
      ).then((m) => m.ClientPreOnboardingModule)
  },
  {
    path: 'transaction',
    loadChildren: () =>
      import('./transact/transact.module').then((m) => m.TransactModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'userotpverification',
    loadChildren: () =>
      import('./verify/verify.module').then((m) => m.VerifyModule)
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('./reports/reports.module').then((m) => m.ReportsModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'client-nse',
    loadChildren: () =>
      import('./profile/client/client.module').then((m) => m.ClientModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'client-profile',
    loadChildren: () =>
      import('./profile/client-profile/client-profile.module').then(
        (m) => m.ClientProfileModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'distributor-profile',
    loadChildren: () =>
      import('./profile/profile/profile.module').then((m) => m.ProfileModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'mb-logout',
    loadChildren: () =>
      import('./mobile-logout/mobile-logout.module').then(
        (m) => m.MobileLogoutModule
      )
  },
  {
    path: 'pdfview',
    loadChildren: () =>
      import('./pdfpopup/pdfpopup.module').then((m) => m.PdfpopupModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'merge-client',
    loadChildren: () =>
      import('./merge-client/merge-client.module').then(
        (m) => m.MergeClientModule
      ),
    canActivate: [AuthGuard, RoleAccessGuard]
  },
  {
    path: 'explore-funds',
    loadChildren: () =>
      import('./explore-funds/explore-funds.module').then(
        (m) => m.ExploreFundsModule
      ),
    canActivate: [AuthGuard]
  },
  {
    path: 'MandateActivation',
    loadChildren: () =>
      import('./open-mandate-tab/open-mandate-tab.module').then(
        (m) => m.OpenMandateTabModule
      )
  },
  {
    path: 'payment',
    loadChildren: () =>
      import('./payment/payment.module').then((m) => m.PaymentModule)
  },
  {
    path: 'mf',
    loadChildren: () => import('./ifa/ifa.module').then((m) => m.IfaModule)
  },
  {
    path: 'version',
    loadChildren: () =>
      import('./version/version.module').then((m) => m.VersionModule)
  },
  { path: 'MpinLogin', component: MPINLoginComponent }, //added by adarsh 14032024
  { path: 'clientPdfscheduleLogin', component: ClientPdfschedulerComponent }, //added by adarsh 06052024

  // { path: 'privacy_policy', component: PrivacyPolicyComponent },
  {
    path: 'DeleteAccount',
    component: DeleteAccountComponent,
    canActivate: [AuthGuard]
  },
  //added by adrsh 05052023
  {
    path: 'value-add-service',
    loadChildren: () =>
      import('./value-add-service/value-add-service.module').then(
        (m) => m.ValueAddServiceModule
      ),
    canActivate: [AuthGuard]
  },
  // { path: 'Disclaimer', component: SitedisclaimerComponent }, old

  {
    path: '', component: LegalSectionComponent,
    children: [
      { path: 'privacy_policy', component: PrivacyPolicyComponent },
      { path: 'terms', component: TermsConditionComponent },
      { path: 'disclaimer', component: DisclaimerComponent },
      { path: 'help_support', component: HelpPolicyComponent },
      { path: '', redirectTo: 'privacy_policy', pathMatch: 'full' } // Default tab
    ]
  },
  { path: 'amcmastertran', component: AmcmastertransactionComponent },
  {
    path: 'business',
    loadChildren: () =>
      import('./aumchart/aumchart.module').then((m) => m.AUMChartModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'transaction', // by pradnesh 03/09/2025
    children: [
      {
        path: 'new-nfo',
        component: BottomsheetbarComponent, 
        children: [
          {
            path: '',
            component: NewnfoComponent 
          }
        ]
      }
    ]
  },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
